// Driver offers (auction) for an active order. Mirrors flutter_client
// order_repository_impl: GET offers list + POST accept/reject. The rider
// accepts one offer to assign the driver; the backend then moves the order to
// DRIVER_ON_THE_WAY. SignalR new_offer_on_order / offer_withdrawn trigger a
// fresh GET (see orderStore), and a 3s poll is the fallback.

import { request } from './http';
import type { Offer } from '../domain/types';

type RawOffer = {
  id: string;
  orderId?: string;
  driverId?: string;
  price?: number;
  driverName?: string | null;
  driverPhoto?: string | null;
  driverRating?: number | null;
  carName?: string | null;
  carNumber?: string | null;
  carColorName?: string | null;
  carPhoto?: string | null;
  expiresAt?: string | null;
};

type OffersEnvelope = { data?: RawOffer[] };

function toOffer(raw: RawOffer): Offer {
  return {
    id: raw.id,
    orderId: raw.orderId ?? '',
    driverId: raw.driverId ?? '',
    price: raw.price ?? 0,
    driverName: raw.driverName ?? null,
    driverPhoto: raw.driverPhoto ?? null,
    driverRating: raw.driverRating ?? null,
    carName: raw.carName ?? null,
    carNumber: raw.carNumber ?? null,
    carColorName: raw.carColorName ?? null,
    carPhoto: raw.carPhoto ?? null,
    expiresAt: raw.expiresAt ?? null,
  };
}

// GET /order/rider/orders/{orderId}/offers
export async function getOrderOffers(orderId: string): Promise<Offer[]> {
  const res = await request<OffersEnvelope>(
    `/order/rider/orders/${encodeURIComponent(orderId)}/offers`,
  );
  const list = Array.isArray(res.data) ? res.data : [];
  return list.map(toOffer);
}

// POST /order/rider/orders/{orderId}/accept-offer  { offerId }
export async function acceptOffer(orderId: string, offerId: string): Promise<void> {
  await request(`/order/rider/orders/${encodeURIComponent(orderId)}/accept-offer`, {
    method: 'POST',
    body: { offerId },
  });
}

// POST /order/rider/orders/{orderId}/reject-offer  { offerId }
export async function rejectOffer(orderId: string, offerId: string): Promise<void> {
  await request(`/order/rider/orders/${encodeURIComponent(orderId)}/reject-offer`, {
    method: 'POST',
    body: { offerId },
  });
}
